import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "@/context/CartContext";
import AgeGate from "@/components/AgeGate";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppButton from "@/components/WhatsAppButton";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Subscription from "@/pages/Subscription";
import Blog from "@/pages/Blog";
import Contact from "@/pages/Contact";
import TrackOrder from "@/pages/TrackOrder";
import Quiz from "@/pages/Quiz";
import Policy from "@/pages/Policy";
import BundleBuilder from "@/pages/BundleBuilder";
import Campaigns from "@/pages/Campaigns";

import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminProducts from "@/admin/AdminProducts";
import AdminInventory from "@/admin/AdminInventory";
import AdminWarehouses from "@/admin/AdminWarehouses";
import AdminBatches from "@/admin/AdminBatches";
import AdminOrders from "@/admin/AdminOrders";
import AdminDistributors from "@/admin/AdminDistributors";
import AdminReports from "@/admin/AdminReports";
import AdminLogs from "@/admin/AdminLogs";
import AdminMessages from "@/admin/AdminMessages";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function StorefrontShell() {
  return (
    <>
      <AgeGate />
      <Header />
      <CartDrawer />
      <WhatsAppButton />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function AdminShell() {
  return (
    <AdminAuthProvider>
      <Outlet />
    </AdminAuthProvider>
  );
}

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster
            position="bottom-center"
            theme="dark"
            toastOptions={{
              style: {
                background: "#161515",
                border: "1px solid rgba(212,175,55,0.3)",
                color: "#F9F6F0",
                fontFamily: "Outfit, sans-serif",
                fontWeight: 300,
              },
            }}
          />
          <Routes>
            {/* Admin (no header/footer/cart) */}
            <Route element={<AdminShell />}>
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route element={<AdminLayout />}>
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/products" element={<AdminProducts />} />
                <Route path="/admin/inventory" element={<AdminInventory />} />
                <Route path="/admin/warehouses" element={<AdminWarehouses />} />
                <Route path="/admin/batches" element={<AdminBatches />} />
                <Route path="/admin/orders" element={<AdminOrders />} />
                <Route path="/admin/distributors" element={<AdminDistributors />} />
                <Route path="/admin/messages" element={<AdminMessages />} />
                <Route path="/admin/reports" element={<AdminReports />} />
                <Route path="/admin/logs" element={<AdminLogs />} />
              </Route>
            </Route>

            {/* Storefront */}
            <Route element={<StorefrontShell />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/track" element={<TrackOrder />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/bundle" element={<BundleBuilder />} />
              <Route path="/campaigns" element={<Campaigns />} />
              <Route path="/policy/:slug" element={<Policy />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
